import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
const IconButton = ({ icon: Icon, value, onClick, disabled, }) => (_jsxs("button", { type: "button", onClick: onClick, disabled: disabled, className: `h-10 relative items-center px-2 rounded-md border border-gray-300 bg-white text-sm font-medium ${disabled ? 'text-gray-200 cursor-default' : 'text-gray-500 hover:bg-gray-50'}`, children: [_jsx("span", { className: "sr-only", children: value }), _jsx(Icon, { className: "h-5 w-5", "aria-hidden": "true" })] }));
IconButton.propTypes = {
    icon: PropTypes.elementType,
    value: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};
export default IconButton;
